module.exports = __webpack_public_path__ + "img/product.9e945e04.png";